module.exports = "agm-map {\r\n  height: 500px;\r\n}"